/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const addToCart = function(variantId, button) {
console.log('like button');
  button.setAttribute('disabled', 'disabled');
   button.classList.add("added");
  button.innerHTML = '<span>Adding...</span>';
 
  document.dispatchEvent(new CustomEvent('theme:loading:start'))
   //button.innerHTML = '<span>Adding</span>';
	
  if (variantId) {
  	fetch('/cart/add.js', {
  	  method: 'POST',
  	  headers: {
  	    'Content-Type': 'application/json'
  	  },
  	  body: JSON.stringify({
  	    'items': [{
  	      'id': variantId,
  	      'quantity': 1
  	      }]
  	  })
  	}).then(() => {
  	  button.removeAttribute('disabled');
       button.innerHTML = '<span>Add to cart</span>';
        button.classList.remove("added");
  	  document.dispatchEvent(new CustomEvent('theme:loading:end'))
  	  document.documentElement.dispatchEvent(new CustomEvent('product:added', {
  	        bubbles: true,
  	        detail: {
  	          variant: variantId,
  	          quantity: 1
  	        }
  	      }))
  	  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
  	    bubbles: true
  	  }))
  	})
  }
}

document.addEventListener('click', function(event) {
	if (!event.target.closest('.Search') && !event.target.closest('.SideBar__Search') && !event.target.classList.contains('.Search') && !event.target.classList.contains('.SideBar__Search')) {
		document.dispatchEvent(new CustomEvent('search:close:blur'));
	}
});

$("#size_chart").click(function(){
    // Add the 'highlight' class to the div with id 'div1'
    $(".PageOverlay").addClass("is-visible");
   $('.Modal' ).attr("aria-hidden", "false");
  });


$(".Modal__Close, .PageOverlay").click(function(){
    // Add the 'highlight' class to the div with id 'div1'
   
   $('.Modal' ).attr("aria-hidden", "true");
    $(".PageOverlay").removeClass("is-visible");
   });

 // Show the first tab and hide the rest
$('#tabs-nav li:first-child').addClass('active');
$('.tab-content').hide();
$('.tab-content:first').show();

// Click function
$('#tabs-nav li').on("click",function(e){
  e.preventDefault();
  $('#tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
   activeTab = activeTab.substring(1);
//  alert(activeTab);
$(document).find("[id='"+activeTab+"']").show();
  return false;
});


 
